<template>
  <div :class="$style.btnGroup">
    <MobileButton v-if="!first"
                  :class="$style.footerBtn"
                  square
                  @click="back()">
      Back
    </MobileButton>
    <MobileButton v-if="showDone || last"
                  :class="$style.footerBtn"
                  :disabled="doneDisable"
                  square
                  @click="done()">
      Done
    </MobileButton>
    <MobileButton v-else
                  :class="$style.footerBtn"
                  :disabled="nextDisable"
                  square
                  @click="next()">
      Next
    </MobileButton>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileButton from '@/apps/mobile/components/MobileButton';
import { Getter } from 'vuex-class';

/**
 * Mobile configurator buttons.
 */
@Component({
  components: {
    MobileButton,
  },
  props: {
    first: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    last: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    doneDisable: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    showDone: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    nextDisable: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class ConfiguratorMobileButtons extends Vue {
  @Getter isMobilePlatform;

  /**
   * Next event.
   */
  next() {
    this.$emit('next');
  }

  /**
   * Back event.
   */
  back() {
    this.$emit('back');
  }

  /**
   * Done event.
   */
  done() {
    this.$emit('next');
  }
}
</script>

<style lang="scss" module>
@import '~@/style/variables.scss';

.btnGroup {
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;

  @media (min-width: $mobile-breakpoint-max + 1px) {
    display: none;
  }
}

.footerBtn {
  flex: auto;
  margin: 0;
  border-radius: 0;

  &+& {
    margin-left: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/configurator/components/ConfiguratorMobileButtons.vue